<template>
  <div class="scrollbar registrationSteps p-3">
    <loader
      :pageloader_value="pageLoader"
      :type="'complete'"
      v-if="pageLoader"
    ></loader>
    <message
      :message="response_msg"
      :messageType="msg_type"
      v-if="response_msg != ''"
    ></message>
    <section class="blockElement fix-mt px-2">
      <!-- <div class="ewalletP">
        <a class="greenBG btnTable unvalidated" href="/upload-document"
          ><img src="../../../../static/fxView/images/x.svg" alt="Icon" />
          Unvalidated Account</a
        >
      </div> -->
      <div class="dashboard mt-3">
        <div
          class="progressSectionArea"
          v-if="parseInt(get_user.verified_status) != 1"
        >
          <div
            class="progressSection whiteBG d-flex align-items-center justify-content-between mb- p-2 border-0 mb-4"
            role="alert"
            v-if="parseInt(get_user.step) < 3"
          >
            <!-- <div class="btContent">
                        <p><strong>Set up your fxview account</strong></p>
                    </div> -->
            <div
              class="processingBar d-flex align-items-center mb-0 border-0 p-0"
            >
              <div class="set-size charts-container mr-3">
                <div class="pie-wrapper progress-45 style-2">
                  <vue-circle
                    :progress="userCstep == 0 ? 20 : userCstep * 20"
                    :size="60"
                    :reverse="false"
                    line-cap="round"
                    :fill="fill"
                    empty-fill="rgba(0, 0, 0, .1)"
                    :animation-start-value="0.0"
                    :start-angle="4.7"
                    insert-mode="append"
                    :thickness="3"
                    :show-percent="true"
                    ref="completeCircle"
                  >
                    <!-- <p>Slot!</p> -->
                  </vue-circle>

                  <!-- <span class="label">{{getCurrentSteps()*20}}<span class="smaller">%</span></span>
                          <div class="pie">
                            <div class="left-side half-circle"></div>
                            <div class="right-side half-circle"></div>
                          </div>
                          <div class="leftshadow"></div> -->
                </div>
              </div>
              <div class="pieText">
                <p>You are just few steps away</p>
                <h3>Activate Your Fxview Account Now!</h3>
              </div>
            </div>
            <div class="barSusscess position-relative">
              <div class="progress mb-3">
                <div
                  class="progress-bar"
                  :style="
                    parseInt(get_user.step) >= 2
                      ? 'width:50%'
                      : parseInt(get_user.step) >= 3
                      ? 'width:100%'
                      : 'width:0%'
                  "
                ></div>
              </div>
              <div
                class="d-flex align-items-center w-100 barDotArea justify-content-between"
              >
                <div
                  class="checkCircle"
                  :class="{ uncheck: parseInt(get_user.step) < 1 }"
                >
                  <feather
                    size="12px"
                    type="check"
                    v-if="parseInt(get_user.step) >= 1"
                  ></feather>
                </div>
                <div
                  class="checkCircle"
                  :class="{ uncheck: parseInt(get_user.step) < 2 }"
                >
                  <feather
                    size="12px"
                    type="check"
                    v-if="parseInt(get_user.step) >= 2"
                  ></feather>
                </div>
                <div
                  class="checkCircle"
                  :class="{ uncheck: parseInt(get_user.step) < 3 }"
                >
                  <feather
                    size="12px"
                    type="check"
                    v-if="parseInt(get_user.step) >= 3"
                  ></feather>
                </div>
              </div>

              <div
                class="d-flex align-items-center justify-content-between inforMation mt-1"
              >
                <p class="mb-0">Personal Information</p>
                <p class="mb-0 text-center">Declaration</p>
                <p class="mb-0 text-right">Upload Personal Documents</p>
              </div>
            </div>
            <!-- <div class="statComplete  mb-0">
                        <h3 class="align-items-center d-flex">{{(parseInt(get_user.step)*33)||'0'}}<sub>%</sub><span class="green">Done</span></h3>                        
                    </div> -->
            <div class="stepComlpe mb-0">
              <router-link
                :to="stepPageOpenFunc(get_user.step)"
                class="prism_btn redBG btn_sm lift"
                >Complete Registration</router-link
              >
            </div>
          </div>
          <div
            class="progressSection whiteBG mb-3 d-flex align-items-center justify-content-between"
            v-else-if="parseInt(get_user.step) == 3"
          >
            <div
              class="btContent d-flex align-items-center justify-content-between"
            >
              <img
                src="../../../../static/fxView/images/steps.svg"
                alt="Complete Registration"
                class="mr-5"
                width="80"
              />
              <div class="mr-5">
                <h4>Your application is under review!</h4>
                <p>Please check the status of your ticket.</p>
              </div>
              <a href="" @click.prevent="redirect()" class="common_btn btn_sm"
                >Click Here</a
              >
            </div>
          </div>
        </div>
        <div class="col-12 p-0">
          <div class="row customMB">
            <div class="col-12 acountStatus">
              <div class="row align-items-center mt-3">
                <div class="col-12 col-lg-7">
                  <!--  {{ dashboardData[0].dashboardData.total_client }}====== -->
                  <!--   {{ dashboardOtherData }}
                                {{ totalSubIB }}
                                {{ totalclient  }} -->
                  <div class="congratulationSection">
                    <!-- {{ get_user}} -->
                    <h3>
                      Dear
                      <span
                        class="green"
                        v-html="
                        get_user.profile.firstname != '' &&
                        get_user.profile.firstname != null
                          ? get_user.profile.firstname +
                            ' ' +
                            get_user.profile.lastname
                          : 'User'
                        "
                      ></span
                      >,
                    </h3>
                    <!--  <p class="light-p">Affiliate ID: <span>FX15236</span></p> -->
                    <p class="light-p">
                      Registration Date:
                      <span
                        v-html="
                          get_user.created != '' && get_user.created != null
                            ? dateDDMMYYFormat(get_user.created)
                            : '-'
                        "
                      ></span>
                    </p>
                  </div>
                  <div class="w-100 d-flex align-items-center totalEarn">
                    <div class="info-box">
                      <span class="info-box-icon bg-info elevation-1">
                        <feather type="file-text"></feather>
                      </span>
                      <div class="info-box-content">
                        <span class="info-box-text font-weight-bold"
                          >Total Commission</span
                        >
                        <!-- <span class="info-box-number text-info" v-html="(affiliateCommList.ibcomm != undefined && affiliateCommList.ibcomm != '' && affiliateCommList.subibcomm != undefined && affiliateCommList.subibcomm != '') ? '$'+(affiliateCommList.subibcomm+affiliateCommList.ibcomm) : '$0'"></span> -->
                        {{ affiliateCommList.totalcomm }}
                        <span class="info-box-number text-info" v-html="affiliateCommList.totalcomm != undefined && affiliateCommList.totalcomm != '' ? '$' + affiliateCommList.totalcomm : '$0'"></span>
                      </div>
                    </div>
                    <div class="info-box">
                      <span class="info-box-icon bg-success elevation-1">
                        <feather type="check-circle"></feather>
                      </span>
                      <div class="info-box-content">
                        <span class="info-box-text font-weight-bold"
                          >This Month</span
                        >
                        <span
                          class="info-box-number text-success"
                          v-html="
                            affiliateCommList.monthcomm != undefined &&
                            affiliateCommList.monthcomm != ''
                              ? '$' + affiliateCommList.monthcomm
                              : '$0'
                          "
                        ></span>
                      </div>
                    </div>
                    <div class="info-box">
                      <span class="info-box-icon bg-warning elevation-1">
                        <feather type="layers"></feather>
                      </span>
                      <div class="info-box-content">
                        <span class="info-box-text font-weight-bold"
                          >Outstanding</span
                        >
                        <span
                          class="info-box-number text-warning"
                          v-html="
                            affiliateCommList.outstanding != undefined &&
                            affiliateCommList.outstanding != '' &&
                            affiliateCommList.outstanding != null
                              ? '$' + Math.round((affiliateCommList.outstanding + Number.EPSILON) *100)/100
                              : '$0'
                          "
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-5">
                  <div class="refreshButoon mb-3 text-right">
                    <a
                      href="#"
                      class="grd_btn d-inline-flex align-items-center"
                      @click.prevent="refreshFunc()"
                      ><feather
                        class="mr-1"
                        size="15px"
                        type="refresh-ccw"
                      ></feather>
                      Refresh
                    </a>
                  </div>
                  <div class="d-flex align-items-center justify-content-end">
                    <div class="referalLinks mr-3">
                      <p>Client Referral</p>
                      <div class="d-flex align-items-center">
                        <span class="d-flex align-items-center fxedCopy w-100">
                          <!-- <span class="infoAtach d-flex align-items-center justify-content-center"><feather type="paperclip" size="17px"></feather></span> -->
                          <input
                            type="text"
                            name=""
                            v-model="homepage_link1"
                            :placeholder="homepage_link1"
                            ref="homepage1"
                            readonly
                          />
                          <!-- <a class="copyUrls d-flex align-items-center justify-content-center" title="Copy URL" href="#" v-on:click.prevent="copyTestingCode('homepage1')">
                                                <feather type="copy" size="17px"></feather>
                                            </a> -->
                          <div class="copied" v-if="copyText == homepage_link1">
                            <p>{{ showcopymsz }}</p>
                          </div>
                          <button
                            class="copyUrls d-flex align-items-center justify-content-center"
                            v-clipboard:copy="homepage_link1"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError"
                          >
                            <feather type="copy" size="17px"></feather>
                          </button>
                        </span>
                        <!-- <div class="shareBtn">
                                            <a class="copyUrl" href="#" title="Share URL"><feather type="share-2" size="17px"></feather></a>
                                        </div> -->
                      </div>
                    </div>
                    <div class="referalLinks">
                      <p>Sub IB Referral</p>
                      <div class="d-flex align-items-center">
                        <span class="d-flex align-items-center fxedCopy w-100">
                          <!-- <span class="infoAtach d-flex align-items-center justify-content-center"><feather type="paperclip" size="17px"></feather></span> -->
                          <input
                            type="text"
                            name=""
                            v-model="subAffLink"
                            :placeholder="subAffLink"
                            ref="subAffLink"
                            readonly
                          />
                          <!-- <a class="copyUrls d-flex align-items-center justify-content-center" title="Copy URL" href="#" v-on:click.prevent="copyTestingCode('subAffLink')">
                                                <feather type="copy" size="17px"></feather>
                                            </a> -->
                          <div class="copied" v-if="copyText == subAffLink">
                            <p>{{ showcopymsz }}</p>
                          </div>
                          <button
                            class="copyUrls d-flex align-items-center justify-content-center"
                            v-clipboard:copy="subAffLink"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError"
                          >
                            <feather type="copy" size="17px"></feather>
                          </button>
                        </span>
                        <!-- <div class="shareBtn">
                                            <a class="copyUrl" href="#" title="Share URL"><feather type="share-2" size="17px"></feather></a>
                                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-12 space"
              v-if="
                dashboardData.length > 0 &&
                dashboardData[0].hasOwnProperty('dashboardData') &&
                dashboardData[0].dashboardData &&
                Object.keys(dashboardData[0].dashboardData).length > 0
              "
            >
              <div class="row">
                <div class="col-12 col-md-3">
                  <div
                    class="card custom-card"
                    :class="show_tab == '1' ? 'active' : 'border-0'"
                  >
                    <div class="card-body">
                      <div class="card-item">
                        <a
                          href="#"
                          @click.prevent="
                            show_tab = '1';
                            chartData('register');
                          "
                        >
                          <div class="card-item-icon card-icon">
                            <feather type="users" size="17px"></feather>
                          </div>
                          <div class="card-item-title mb-3">
                            <label
                              class="main-content-label tx-13 font-weight-bold mb-0"
                              >Total Clients</label
                            >
                            <!-- <span class="d-block tx-12 mb-0 text-muted">Previous month vs this months</span>  -->
                          </div>
                          <div class="card-item-body">
                            <div class="card-item-stat">
                              <h4
                                class="font-weight-bold"
                                v-html="
                                  dashboardData[0].dashboardData.total_client !=
                                    '' &&
                                  dashboardData[0].dashboardData.total_client !=
                                    null
                                    ? dashboardData[0].dashboardData
                                        .total_client
                                    : 0
                                "
                              ></h4>
                              <!-- <small class="cursor-pointer d-flex align-items-center green"><b class="mr-1">View Chart</b> <feather type="chevron-down" size="14px"></feather></small> -->
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div
                    class="card custom-card"
                    :class="show_tab == '2' ? 'active' : 'border-0'"
                  >
                    <div class="card-body">
                      <div class="card-item">
                        <a
                          href="#"
                          @click.prevent="
                            show_tab = '2';
                            chartData('unverified');
                          "
                        >
                          <div class="card-item-icon card-icon">
                            <feather type="airplay" size="17px"></feather>
                          </div>
                          <div class="card-item-title mb-3">
                            <label
                              class="main-content-label tx-13 font-weight-bold mb-0"
                              >Total Unverified</label
                            >
                            <!-- <span class="d-block tx-12 mb-0 text-muted">Previous month vs this months</span>  -->
                          </div>
                          <div class="card-item-body">
                            <div class="card-item-stat">
                              <h4
                                class="font-weight-bold"
                                v-html="
                                  dashboardData[0].dashboardData.total_client !=
                                    '' &&
                                  dashboardData[0].dashboardData.total_client !=
                                    null
                                    ? dashboardData[0].dashboardData
                                        .total_client -
                                      dashboardData[0].dashboardData
                                        .verified_client
                                    : 0
                                "
                              ></h4>
                              <!-- <small class="cursor-pointer d-flex align-items-center green"><b class="mr-1">View Chart</b> <feather type="chevron-down" size="14px"></feather></small> -->
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div
                    class="card custom-card"
                    :class="show_tab == '3' ? 'active' : 'border-0'"
                  >
                    <div class="card-body">
                      <div class="card-item">
                        <a
                          href="#"
                          @click.prevent="
                            show_tab = '3';
                            chartData('verified');
                          "
                        >
                          <div class="card-item-icon card-icon">
                            <feather type="check-circle" size="17px"></feather>
                          </div>
                          <div class="card-item-title mb-3">
                            <label
                              class="main-content-label tx-13 font-weight-bold mb-0"
                              >Total Verified</label
                            >
                            <!-- <span class="d-block tx-12 mb-0 text-muted">Previous month vs this months</span>  -->
                          </div>
                          <div class="card-item-body">
                            <div class="card-item-stat">
                              <h4
                                class="font-weight-bold"
                                v-html="
                                  dashboardData[0].dashboardData
                                    .verified_client != '' &&
                                  dashboardData[0].dashboardData
                                    .verified_client != null
                                    ? dashboardData[0].dashboardData
                                        .verified_client
                                    : 0
                                "
                              ></h4>
                              <!-- <small class="cursor-pointer d-flex align-items-center green"><b class="mr-1">View Chart</b> <feather type="chevron-down" size="14px"></feather></small> -->
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div
                    class="card custom-card"
                    :class="show_tab == '4' ? 'active' : 'border-0'"
                  >
                    <div class="card-body">
                      <div class="card-item">
                        <a
                          href="#"
                          @click.prevent="
                            show_tab = '4';
                            chartData('funded');
                          "
                        >
                          <div class="card-item-icon card-icon">
                            <feather type="archive" size="17px"></feather>
                          </div>
                          <div class="card-item-title mb-3">
                            <label
                              class="main-content-label tx-13 font-weight-bold mb-0"
                              >Total Funded</label
                            >
                            <!-- <span class="d-block tx-12 mb-0 text-muted">Previous month vs this months</span>  -->
                          </div>
                          <div class="card-item-body">
                            <div class="card-item-stat">
                              <h4
                                class="font-weight-bold"
                                v-html="
                                  dashboardData[0].dashboardData.total_funded !=
                                    '' &&
                                  dashboardData[0].dashboardData.total_funded !=
                                    null
                                    ? dashboardData[0].dashboardData
                                        .total_funded
                                    : 0
                                "
                              ></h4>
                              <!-- <small class="cursor-pointer d-flex align-items-center green"><b class="mr-1">View Chart</b> <feather type="chevron-down" size="14px"></feather></small> -->
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 space" v-if="!pageLoader">
              <div
                class="chart"
                ref="chartdiv"
                style="height: 300px"
                v-if="no_data > 0"
              ></div>
              <div class="chart" ref="chartdiv" v-else>
                <div class="noChartData whiteBG">
                  <img
                    src="../../../../static/fxView/images/line-chart.svg"
                    width="120px"
                    alt="Icon"
                  />
                  <p>No Data</p>
                </div>
              </div>
              <!-- <div class="showChartView whiteBG box-shadow" v-if="!pageLoader &&  tradingView !== '' && show_tab == '1'">
                            <img src="../../../../static/fxView/images/lineChart.jpg" alt="Icon">
                        </div>
                        <div class="showChartView whiteBG box-shadow" v-if="!pageLoader &&  tradingView !== '' && show_tab == '2'">
                            <img src="../../../../static/fxView/images/lineChart.jpg" alt="Icon">
                        </div>
                        <div class="showChartView whiteBG box-shadow" v-if="!pageLoader &&  tradingView !== '' && show_tab == '3'">
                            <img src="../../../../static/fxView/images/lineChart.jpg" alt="Icon">
                        </div>
                        <div class="showChartView whiteBG box-shadow" v-if="!pageLoader &&  tradingView !== '' && show_tab == '4'">
                            <img src="../../../../static/fxView/images/lineChart.jpg" alt="Icon">
                        </div> -->
            </div>
            <div class="col-12 space">
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="card custom-card border-0 h-100">
                    <div class="card-body">
                      <div class="card-item">
                        <!-- {{ affiliateCommList }}  -->
                        <div
                          class="d-flex align-items-center justify-content-between mb-3"
                        >
                          <label class="main-content-label font-weight-bold"
                            >Monthly Earnings</label
                          >
                          <router-link
                            class="d-flex align-items-center"
                            to="/affiliate-earnings"
                            >
                            <!-- <feather
                              class="mr-1"
                              type="check-circle"
                              size="14px"
                            ></feather> -->
                            View All</router-link
                          >
                        </div>
                        <template v-if="
                            !pageLoader &&
                            affiliateCommList.records &&
                            affiliateCommList.records.length > 0
                          ">
                        <app-barChart
                          :monthlyCommision="affiliateCommList.records"
                          
                        ></app-barChart>
                        <p class="text-center gray-color pt-1 small-text">(in USD)</p>
                      </template>
                        <div class="chart" ref="chartdiv" v-else>
                          <div class="noChartData whiteBG">
                            <img
                              src="../../../../static/fxView/images/line-chart.svg"
                              width="100px"
                              alt="Icon"
                            />
                            <p>No Data</p>
                          </div>
                        </div>
                        <!-- <div class="row"> 
                                                <div class="col-2"> 
                                                    <span class="">June 21</span> 
                                                </div> 
                                                <div class="col-8 my-auto"> 
                                                    <div class="progress">
                                                      <div class="progress-bar bg-success" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div> 
                                                <div class="col-2"> 
                                                    <div class="d-flex justify-content-end"> 
                                                        <span class="font-weight-bold">$0</span> 
                                                    </div> 
                                                </div> 
                                            </div> 
                                            <div class="row mt-3 border-top pt-3"> 
                                                <div class="col-2"> 
                                                    <span class="">May 21</span> 
                                                </div> 
                                                <div class="col-8 my-auto"> 
                                                    <div class="progress">
                                                      <div class="progress-bar bg-success" role="progressbar" style="width: 75%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div> 
                                                <div class="col-2"> 
                                                    <div class="d-flex justify-content-end"> 
                                                        <span class="font-weight-bold">$0</span> 
                                                    </div> 
                                                </div> 
                                            </div> 
                                             <div class="row mt-3 border-top pt-3"> 
                                                <div class="col-2"> 
                                                    <span class="">May 18</span> 
                                                </div> 
                                                <div class="col-8 my-auto"> 
                                                    <div class="progress">
                                                      <div class="progress-bar bg-success" role="progressbar" style="width: 85%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div> 
                                                <div class="col-2"> 
                                                    <div class="d-flex justify-content-end"> 
                                                        <span class="font-weight-bold">$0</span> 
                                                    </div> 
                                                </div> 
                                            </div> 
                                             <div class="row mt-3 border-top pt-3"> 
                                                <div class="col-2"> 
                                                    <span class="">May 15</span> 
                                                </div> 
                                                <div class="col-8 my-auto"> 
                                                    <div class="progress">
                                                      <div class="progress-bar bg-success" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div> 
                                                <div class="col-2"> 
                                                    <div class="d-flex justify-content-end"> 
                                                        <span class="font-weight-bold">$0</span> 
                                                    </div> 
                                                </div> 
                                            </div>  -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="card custom-card border-0 h-100">
                    <div class="card-body">
                      <div class="card-item">
                        <div
                          class="d-flex align-items-center justify-content-between mb-2"
                        >
                          <!-- {{ userList }} -->
                          <label class="main-content-label font-weight-bold"
                            >Client List</label
                          >
                          <router-link
                            class="d-flex align-items-center"
                            to="/client-details"
                            >
                            <!-- <feather
                              class="mr-1"
                              type="check-circle"
                              size="14px"
                            ></feather> -->
                            View All</router-link
                          >
                        </div>
                        <div class="scrollable-x">
                          <table
                            class="table table-striped focus-on abbr adminTable m-0"
                          >
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Registration date</th>
                                <th>Revenue</th>
                                <th>My Earnings</th>
                              </tr>
                            </thead>
                            <tbody v-if="userList.totalRecords > 0">
                              <tr v-for="(list, index) in userList.records.slice(0, 5)">
                                <td
                                  v-html="list.username || 'New User'"
                                ></td>
                                <td
                                  v-html="
                                    list.created != '' && list.created != null
                                      ? getHumanDate(list.created)
                                      : '-'
                                  "
                                ></td>
                                <td>{{ list.totalRevenue }}</td>
                                <td>{{ list.myCommission }}</td>
                              </tr>
                            </tbody>
                            <tbody v-else-if="userList.totalRecords == 0">
                              <tr>
                                <td colspan="5">
                                  <loader
                                    :pageloader_value="pageLoader"
                                    :type="'table'"
                                    :colspan="5"
                                    :list="userList"
                                    v-if="pageLoader == false"
                                  ></loader>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as types from '../../../types'
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
am4core.useTheme(am4themes_animated);

import { fxViewMixins } from "@/plugins/fxView";
import { mapActions } from 'vuex'
import moment from "moment";
import JsonExcel from "json-to-excel";
import VueCircle from "vue2-circle-progress"; 
import BarChart from "../shared/bar_chart";
import {
  BarChart2Icon,
  PieChartIcon,
  UserIcon,
  EyeIcon,
} from "vue-feather-icons";
export default {
  name: "DASHBOARD",
  mixins: [fxViewMixins],
  data() {
    return {
      pageTitle: this.$options.name,
      homepage_link: "",
      homepage_link1: "",
      subAffLink: "",
      dashboardOtherData: {},
      totalSubIB: [],
      totalclient: [],
      pageLoader: false,
      show_tab: "1",
      fill: { color: "#25c16f" },
      response_msg: "",
      msg_type: "",
      copyText: "",
      showcopymsz: "",

      no_data: 0,
      chart_data: [],
    };
  },
  components: {
    BarChart2Icon,
    PieChartIcon,
    UserIcon,
    EyeIcon,
    VueCircle,
    appBarChart: BarChart,
  },
  methods: {
    ...mapActions({
      _runRefreshData: types.RUN_STATE_LOAD,
    }),
    refreshFunc() {
      location.reload();
    },
    onCopy(e) {
      var _that = this;
      _that.copyText = e.text;
      if (_that.copyText) {
        _that.showcopymsz = "Copied";
      }
      setTimeout(function () {
        _that.showcopymsz = "";
        _that.copyText = "";
      }, 5000);
    },
    onError(e) {
      var _that = this;
      try {
        _that.showcopymsz = "Unable to Copy";
        setTimeout(function () {
          _that.showcopymsz = "";
          _that.copyText = "";
        }, 5000);
      } catch (e) {}
    },
    getHumanDate(date) {
      return this.$parent.dateDDMMFormat(date);
    },
    dateDDMMYYFormat(date) {
      return this.$parent.dateDDMMYYFormat(date);
    },
    copyTestingCode(copyFrom) {
      const _that = this;
      if (copyFrom == "homepage") {
        this.selectText(this.$refs.homepage);
      }

      if (copyFrom == "homepage1") {
        this.selectText(this.$refs.homepage1);
      }

      if (copyFrom == "subAffLink") {
        this.selectText(this.$refs.subAffLink);
        // e.g. <div ref="text">
      }
      try {
        document.execCommand("copy");
        that.response_msg = "Copied to clipboard";
        that.msg_type = "success";
        //_that._messageDisplayFunction(_that,'Copied','success');
        if (window.getSelection) {
          if (window.getSelection().empty) {
            // Chrome
            window.getSelection().empty();
          } else if (window.getSelection().removeAllRanges) {
            // Firefox
            window.getSelection().removeAllRanges();
          }
        } else if (document.selection) {
          // IE?
          document.selection.empty();
        }
      } catch (err) {
        _that.response_msg = "Unable to copy";
        _that.msg_type = "error";
        // _that._messageDisplayFunction(_that,'Unable to copy','error');
      }
    },
    selectText(element) {
      var range;
      if (document.selection) {
        // IE
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
    listing() {
      let inputJson = {
        globalParams: {
          filter: {},
          sort: [],
          search: "",
          page: "1",
          perPage: 15,
        },
        localParams: {
          parameter: this,
        },
      };

      this._runGetUserList(inputJson);
    },

    //=============================================== chart Data ==========================
    chartListing() {
      let inputJson = {
        globalParams: {
          filter: {},
          sort: [],
          search: this.search,
          page: this.page,
          perPage: this.pageLimit,
        },
        localParams: { parameter: this, page: 'dashboard' },
      };
      //input_json.globalParams.dob   =   moment(_that.ind_dob).format('YYYY-MM-DD')
      this._runGetdashboardChartData(inputJson);
    },
    intializeChart() {
      let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);
      am4core.addLicense("ch-custom-attribution");
      chart.paddingRight = 20;

      // let visits = 10;
      // for (let i = 1; i < 366; i++) {
      //   visits += Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
      //   data.push({ date: new Date(2018, 0, i), name: "name" + i, value: visits });
      // }
      chart.data = this.chart_data;
      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.grid.template.location = 0;
      dateAxis.baseInterval = {
        timeUnit: "month",
      };
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      valueAxis.tooltip.disabled = true;
      valueAxis.renderer.minWidth = 35;

      let series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.dateX = "date";
      series.dataFields.valueY = "value";

      series.tooltipText = "{valueY.value}";
      chart.cursor = new am4charts.XYCursor();
      console.log("here", this.chart_data);

      this.chart = chart;
    },
    chartData(data) {
      if (data == "register") {
        if (Object(this.dashboardChartData.registered).length > 0) {
          this.no_data = Object(this.dashboardChartData.registered).length;
          let lists = [];

          let jsonEl = [];
          $.each(this.dashboardChartData.registered, function (key, value) {
            jsonEl = JSON.parse(value.data);
            // jsonEl.date = moment(jsonEl.date, "YYYY-MM-DD").format("MMM");
            lists.push(jsonEl);
          });

          if (
            Object(this.dashboardChartData.registered).length == lists.length
          ) {
            //this.chart_data = [{"date": "2021-06-11", "value": 2}]
            this.chart_data = lists;
            this.intializeChart();
          }
        }
      } else if (data == "unverified") {
        if (
          this.dashboardChartData.hasOwnProperty("unverified") &&
          this.dashboardChartData.unverified.length > 0
        ) {
          this.no_data = Object(this.dashboardChartData.unverified).length;
          let lists = [];

          let jsonE2 = [];
          $.each(this.dashboardChartData.unverified, function (key, value) {
            jsonE2 = JSON.parse(value.data);
            // jsonE2.date = moment(jsonE2.date, "YYYY-MM-DD").format("MMM");
            lists.push(jsonE2);
          });
          if (
            Object(this.dashboardChartData.unverified).length == lists.length
          ) {
            this.chart_data = lists;
            this.intializeChart();
          }
        }
      } else if (data == "verified") {
        if (
          this.dashboardChartData.hasOwnProperty("verified") &&
          this.dashboardChartData.verified.length > 0
        ) {
          this.no_data = Object(this.dashboardChartData.verified).length;
          let lists = [];

          let jsonE2 = [];
          $.each(this.dashboardChartData.verified, function (key, value) {
            jsonE2 = JSON.parse(value.data);
            // jsonE2.date = moment(jsonE2.date, "YYYY-MM-DD").format("MMM");
            lists.push(jsonE2);
          });
          if (Object(this.dashboardChartData.verified).length == lists.length) {
            this.chart_data = lists;
            this.intializeChart();
          }
        }
      } else {
        if (
          this.dashboardChartData.hasOwnProperty("funded") &&
          this.dashboardChartData.funded.length > 0
        ) {
          this.no_data = Object(this.dashboardChartData.funded).length;
          let lists = [];

          let jsonE2 = [];
          $.each(this.dashboardChartData.funded, function (key, value) {
            jsonE2 = JSON.parse(value.data);
            lists.push(jsonE2);
          });
          if (Object(this.dashboardChartData.funded).length == lists.length) {
            this.chart_data = lists;
            this.intializeChart();
          }
        }
      }

      //this.intializeChart()
    },
    getReferalLinks() {
      let encryptString =
        this.get_user.profile.user_id + "||" + this.get_user.rm_id;
      this.homepage_link =
        this.$env_var.ibLink +
        "register?refLink=" +
        window.btoa(0 + "||" + this.get_user.rm_id);
        if(localStorage.getItem('ib-origin') && localStorage.getItem('ib-origin') == 'eu'){
           this.homepage_link1 =
        this.$env_var.eucpLink +
        "register?refLink=" +
        window.btoa(this.get_user.profile.user_id) +
        "&refRm=" +
        window.btoa(this.get_user.rm_id);
        }else{
        this.homepage_link1 =
          this.$env_var.cpLink +
          "register?refLink=" +
          window.btoa(this.get_user.profile.user_id) +
          "&refRm=" +
          window.btoa(this.get_user.rm_id);
        }
      this.subAffLink =
        this.$env_var.ibLink + "register?refLink=" + window.btoa(encryptString);
    },
    //=============================================== End chart Data ==========================
  },
  computed: {
    userCstep: function () {
      let currentStep = this.get_user.step;
      if ("tempStep" in this.get_user && currentStep < this.get_user.tempStep) {
        currentStep = this.get_user.tempStep;
      }
      this.userStep = currentStep;

      if (parseInt(this.userStep) == 0) {
        if (this.$refs.completeCircle) {
          this.$refs.completeCircle.updateProgress(20);
        }
      } else {
        if (this.$refs.completeCircle) {
          this.$refs.completeCircle.updateProgress((this.userStep + 1) * 20);
        }
      }

      return this.get_user.step + 1;
    },
  },
  mounted(){
    if(Object.keys(this.get_user).length && this.get_user.rm_id){
      this.getReferalLinks();
    } else {
      this._runRefreshData({'globalParams' :{},'localParams' :{ "parameter" : this, 'page' :'dashboard'}})
    }
  },
  created() {
    this.setData(this.pageTitle);
    this.listing();

    //================== chart Data ==========================
    this.chartListing();
    //================== chart Data ==========================

    this._runGetAffiliateEarning({
      globalParams: {},
      localParams: { parameter: this },
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/users/dashboard.vue